module.exports = __webpack_public_path__ + "img/ico_p_gift.6a207eb.svg";